const nameData = "localidades"; // Define la entidad dinámica
const nameDataSingular = "localidad"; // Para el caso singular

export const fetchEntityData = async (getEntityPanelData, searchTerm, searchIDFilter,searchIDSecondFilter,numPagina, filas) => {
  try {
    const data = await getEntityPanelData(searchTerm,searchIDFilter, searchIDSecondFilter,numPagina, filas);
    if (data) {
      const totalPage = data.pagination.totalPage || 1;
      return {
        dataEntity: data[nameData] || [], // Usa nameData dinámicamente
        totalItems: data.pagination.totalItems || 0,
        totalPage,
      };
    }
  } catch (error) {
    console.error(`Error al cargar ${nameData}:`, error);
    throw error;
  }
};

export const deleteItem = async (deleteEntityData, selectedItem) => {
  try {
    await deleteEntityData(selectedItem);
  } catch (error) {
    console.error(`Error al eliminar el ${nameDataSingular}:`, error);
    throw error;
  }
};
